export default __webpack_public_path__ + "static/media/53_photo.e87fcea3.jpg";